import React, { Component } from "react";
import CIR_Payroll from "../../../components/CIR_Payroll/CIR_Payroll";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CardForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente Card
================================================================================ */
class CIR_PayrollForm extends Component{
    render(){
        return(
            <CIR_Payroll/>  
        )   
    }
}

export default CIR_PayrollForm;